module.exports = __webpack_public_path__ + "img/run_right.3d16e3e4.jpg";